import { SaveDocumentForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type SaveDocumentProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveDocumentProps) => {
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save document'
      subTitle='Upload your file'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveDocumentForm.FC
        id={props.id}
        folderId={params.folderId ?? ''}
        projectId={params.projectId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
